module.exports = __webpack_public_path__ + "img/osago-arrow.63b551d.png";